import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import useAuth from "../hooks/useAuth";
import useRetryFetch from "../hooks/useRetryFetch";
import { tryGetUserProfile } from "../api/auth";
import { PageLoader } from "./ui/page-loader";

const LoginFromGoogle = () => {
  const { setAuth, setUser } = useAuth();
  const retryFetch = useRetryFetch();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [searchParams] = useSearchParams();

  const redirect = () => {
    let oldLocationState = sessionStorage.getItem("locationstate");
    if (oldLocationState) {
      const from = JSON.parse(oldLocationState).from;
      const fromPathname = from?.pathname || "/portal";
      const fromSearch = from?.search || "";
      const fromHash = from?.hash || "";
      sessionStorage.removeItem("locationstate");
      const prefix = fromSearch ? '&' : '?';
      const timestamp = `${prefix}t=${Date.now()}`;
      navigate(`${fromPathname}${fromSearch}${timestamp}${fromHash}`, { replace: true });
    } else {
      navigate(`/portal?t=${Date.now()}`);
    }
  };

  const loadUserRoles = async ({ email, accessToken }) => {
    const authData = { email, accessToken };
    // accessToken must be set to fetch user profile
    setAuth(authData);

    const userProfile = await tryGetUserProfile(retryFetch);
    if (userProfile) {
      userProfile.roles ??= [];
      setUser(userProfile);
    } else {
      toast.warning(t("msg_error_failed_loading_user_roles"));
    }

    redirect();
  };

  useEffect(() => {
    let accessToken = searchParams.get("accessToken");
    let email = searchParams.get("email");
    console.log(`LoginFromGoogle.jsx found accessToken and email ${email}`);
    if (accessToken && email) {
      loadUserRoles({ email, accessToken }).catch(console.error);
    } else {
      navigate(`/login?t=${Date.now()}`);
    }
  }, []);

  return (
        <PageLoader fullScreen />
  );
};

export default LoginFromGoogle;
